import React from 'react';
const ScoreTypesStatsViewsButton = ({ icon, title, selectedVisualizationType, setVisualizationType, buttonVisualizationType }) => {
    return (React.createElement("button", { className: `ui icon button ${selectedVisualizationType === buttonVisualizationType ? 'primary' : ''}`, onClick: () => setVisualizationType(buttonVisualizationType), title: title }, icon));
};
export default ScoreTypesStatsViewsButton;
